import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-outdated-address-modal',
  templateUrl: './outdated-address-modal.component.html',
  styleUrls: ['./outdated-address-modal.component.css']
})
export class OutdatedAddressModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<OutdatedAddressModalComponent>) { }

  patient: any = this.data.patient;
  formattedAddress: string = this.data?.formattedAddress;
  phoneMask: string = this.data?.phoneMask;
  ngOnInit(): void {
  }

  sendLinkAndContinue() {
    this.patient.sendSmsForUpdateAddress = true;
    this.matDialogRef.close({ patient: this.patient });
  }

  return() {
    this.matDialogRef.close(false);
  }
}